export const setList = {
  "count": "\"24\"",
  "setList": [
    {
      "bass": [
        "이승하"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "이지호"
      ],
      "keyboard": [
        "이서영",
        "박민석"
      ],
      "number": "1",
      "songArtist": "죠지",
      "songName": "Boat",
      "vocal": [
        "최현석"
      ],
      // "lyric": "{I'm on a boat\n눈에보이는 사방이 바다야\n갓 잡아올린 생선을 회쳐서먹어\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리\nI'm on a boat\n내가 원했던건 그게 전부야\n흘러가는파도와 내 흔들리는 보트\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리}\n\n지는 해를 바라보면서\n잠들수있는 낙이 필요해\n떠나지말란 법은 없지만\n두고가야할게많아 겁이나는걸\n가끔은 한심한 꿈들이 필요해\nBut 나를 바라보는 눈이 너무많아\n저 멀리 갈수있는 배가 필요해\n내 삶은 파도 따라서 흘러가야돼\n\n{I'm on a boat\n눈에보이는 사방이 바다야\n갓 잡아올린 생선을 회쳐서먹어\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리\nI'm on a boat\n내가 원했던건 그게 전부야\n흘러가는파도와 내 흔들리는 보트\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리}\n지금은 꽤나 멀리온듯해\n생각했던 모습과는 조금달라도\n괜찮아 이건모두 내가 바랬던\n이상의 일부야 이정돈 감수해야지\n큰 파도가 날 덮칠수도있지만\n뜻밖의 사고가 날 수도있지만\nI'll be ok 난 내 삶에 만족해\n날 향한 걱정과 우려는 필요없어\n\n{I'm on a boat\n눈에보이는 사방이 바다야\n갓 잡아올린 생선을 회쳐서먹어\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리\nI'm on a boat\n내가 원했던건 그게전부야\n흘러가는파도와 내 흔들리는 보트\nI'm on a boat\n멀어지는 도시\nWe're going on\n어딘가로 멀리멀리\nx2\n}"
    },
    {
      "bass": [
        "홍윤표"
      ],
      "drum": [
        "김영균"
      ],
      "guitar": [
        "김민제",
        "최현석"
      ],
      "keyboard": [
        "황정빈",
        "김상경"
      ],
      "number": "2",
      "songArtist": "권진아",
      "songName": "Fly away",
      "vocal": [
        "김다솔"
      ],
      // "lyric" : "하루 종일 엉망이었었어\n일어나서부터 기분이 뭐 같았어\n아침을 먹는데 확인한 핸드폰엔\n밤사이 와있는 네 문잘 보고선 기분을 잡쳤어\n\n또다시 날 찔러보는 네가 뻔히 보여서\n거지 같지 그다지 썩 반갑지 않으니까\n네가 힘들어하는지 어떤지\n이젠 아무렇지도 않아 오 난\n하나도 안 미안해서 미안해\n\n{I'm gonna fly away gonna fly away\n마음은 한결 가볍지\n날아갈 듯 가볍지\nI'll never cry again yeah I'll never cry again\n이제 훌훌 털어버리고}\n\n흔들렸어 솔직히 좋았어 너의 연락이\n외롭고 힘들 때 항상 넌 내 옆에 없었어\n누구보다 소중했던 너 땜에 깨달은 게 하나 있어\n나도 역시 내가 제일 중요해\n\n{I'm gonna fly away gonna fly away\n마음은 한결 가볍지\n날아갈 듯 가볍지\nI'll never cry again yeah I'll never cry again\n이제 훌훌 털어버리고}\n\n매일 밤 너를 그리던 내가\n이젠 더 이상 나는 널 찾지 않아\n왜 억울해? 미안해? 웃기지 말아\n절대 나는 돌아가지 않아\n너도 아팠겠지만 과연\n나만큼이었을까\n언젠가 너를 생각하면 한번 피식\n웃고 말겠지\n\n{Gonna fly away gonna fly away\n마음은 한결 가볍지\n날아갈 듯 가볍지\nI'll never cry again yeah I'll never cry again\n이제 훌훌 털어버리고\nx2}\n\n여름은 모두 끝났지\n다시 오지 않겠지\nI'll never cry again yeah I'll never cry again\n이제 웃을 일만 남았네\n",
    },
    {
      "bass": [
        "이승하"
      ],
      "drum": [
        "이유준"
      ],
      "guitar": [
        "김민제",
        "이주원"
      ],
      "number": "3",
      "songArtist": "Avril Lavigne",
      "songName": "Sk8er Boi",
      "vocal": [
        "김민지"
      ],
      // "lyric" : "He was a boy, She was a girl\nCan I make it anymore obvious?\nHe was a punk. She did ballet.\nWhat more can I say?\nHe wanted her. She'd never tell.\nsecretly she wanted him as well.\nBut all of her friends, Stuck up their nose.\nThey had a problem with his baggy clothes.\n\nHe was a sk8er boi\nshe said see ya later boi.\nHe wasn't good enough for her.\nShe had a pretty face but her head was up in space.\nShe needed to come back down to earth. \n\nFive years from now she sits at home\nFeeding the baby she's all alone.\nShe turns on TV and guess who she sees.\nSk8er boi rocking up MTV.\nShe calls up her friends.\nThey already know\nAnd they've all got tickets to see his show.\nShe tags along, stands in the crowd.\nLooks up at the man that she turned down.\n\nHe was a sk8er boi\nshe said see ya later boi.\nHe wasn't good enough for her.\nNow he's a superstar slamming on his guitar\ndoes your pretty face see what he's worth?\n\nHe was a sk8er boi\nshe said see ya later boi.\nHe wasn't good enough for her.\nNow he's a superstar slamming on his guitar\ndoes your pretty face see what he's worth?\n\nSorry girl but you missed out.\nWell tough luck that boi's mine now.\nWe are more than just good friends.\nThis is how the story ends.\nToo bad that you couldn't see.\nSee the man that boi could be.\nThere is more than meets the eye,\nI see the soul that is inside.\nHe's just a boi, and I'm just a girl.\nCan I make it anymore obvious?\nWe are in love.\nHaven't you heard how we rock each other's world?\n\nI met the sk8er boi I said see ya later boi.\nI'll be backstage after the show.\nI'll be at the studio singing the song we wrote\nabout a girl he use to know.\nI met the sk8er boi I said see ya later boi.\nI'll be backstage after the show.\nI'll be at the studio singing the song he wrote\nabout a girl you used to know\n"
    },
    {
      "bass": [
        "이승하"
      ],
      "drum": [
        "이유진"
      ],
      "guitar": [
        "조현호",
        "이주원"
      ],
      "keyboard": [
        "장우종"
      ],
      "number": "4",
      "songArtist": "The Volunteers",
      "songName": "Summer",
      "vocal": [
        "최승혜"
      ],
      // "lyric" : "(Our eyes are closed but\nwe know when the sun is near us\nWe'll be in love forever\nMy door had been ripped off somehow\nBut now it's constantly fixed by you\nI hate to admit it\n\nDon't you let me slip away\nWhen I fight for silly things\nDon't show your back to me\nWhen we fall down together\n\nDon't you let me get away\nWhen I pretend to be okay\nPromise I'll be true to you\nBut somehow we will realize\nSomeday we'll stand here by the sun\nDon't let me get away)\nx2\n"
    },
    {
      "bass": [
        "한지우"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "강재호"
      ],
      "keyboard": [
        "황정빈"
      ],
      "number": "5",
      "songArtist": "Jorja Smith",
      "songName": "Teenage Fantasy",
      "vocal": [
        "이시연"
      ]
    },
    {
      "bass": [
        "이서영"
      ],
      "drum": [
        "김영균"
      ],
      "guitar": [
        "김원후",
        "이지호"
      ],
      "keyboard": [
        "이서은",
        "박민석"
      ],
      "number": "6",
      "songArtist": "백예린",
      "songName": "la la la lovesong",
      "vocal": [
        "김다솔"
      ]
    },
    {
      "bass": [
        "배유호"
      ],
      "drum": [
        "이유준"
      ],
      "guitar": [
        "김원후",
        "권예찬"
      ],
      "keyboard": [
        "이서영"
      ],
      "number": "7",
      "songArtist": "DAY6",
      "songName": "한 페이지가 될 수 있게",
      "vocal": [
        "김민지",
        "김선우"
      ]
    },
    {
      "bass": [
        "홍윤표"
      ],
      "drum": [
        "김석진"
      ],
      "guitar": [
        "강재호",
        "이지호"
      ],
      "keyboard": [
        "김민정"
      ],
      "number": "8",
      "songArtist": "유다빈밴드",
      "songName": "안중",
      "vocal": [
        "김준서"
      ]
    },
    {
      "bass": [
        "홍윤표"
      ],
      "drum": [
        "김영균"
      ],
      "guitar": [
        "김상경",
        "박건도",
        "박지한"
      ],
      "keyboard": [
        "박민석"
      ],
      "number": "9",
      "songArtist": "오대천왕",
      "songName": "멋진 헛간",
      "vocal": [
        "박지한",
        "박건도"
      ]
    },
    {
      "bass": [
        "한지우"
      ],
      "drum": [
        "김영균"
      ],
      "guitar": [
        "김상경",
        "권예찬"
      ],
      "number": "10",
      "songArtist": "브로큰 발렌타인",
      "songName": "Poker Face",
      "vocal": [
        "박건도"
      ]
    },
    {
      "bass": [
        "한지우"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "강재호",
        "박건도"
      ],
      "keyboard": [
        "박민석"
      ],
      "number": "11",
      "songArtist": "자작곡",
      "songName": "권예찬",
      "vocal": [
        "박건도"
      ],
      "lyric": "안녕하세요 쟤 이름을 소개할게요 쟤 이름은 권예찬\n한 달만에 알바 네 번을 짤리고 꼬라지가 좀 난 상태에요\n\n여자친구 만들려고 미팅 나갔다가 퇴짜맞은 권예찬\n술자리에 안주 대신 이 얘길 들으면 그 날은 집에 못가죠\n\n{(권예찬)}\n선배 말은 귓등으로 들어\n{(권예찬)}\n메트로놈 연습 갖다버려\n{(권예찬)}\n술에 꼴아 길바닥에 누워\n{(권예찬)}\n선배 말은 귓등으로 들어\n{(권예찬)}\n메트로놈 연습 갖다버려\n{(권예찬)}\n술에 꼴아 길바닥에 누워\n{x4}\n\n"
    },
    {
      "bass": [
        "장우종"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "김상경",
        "김원후"
      ],
      "keyboard": [
        "홍윤표"
      ],
      "number": "12",
      "songArtist": "자작곡",
      "songName": "K2",
      "vocal": [
        "김원후"
      ],
      "lyric" : "바람에 날리는 낙엽과 같이\n오래된 영화의 한장면 같이\n우린 아마 색이 바라겠지만\n\n오래된 노래의 한 소절 같이\n유명한 소설의 한 구절 같이\n우린 아마 영원할거야\n\n오래전 적어놓은 메모들 같이\n언젠가 맡았던 향기와 같이\n우린 아마 점점 잊히겠지만\n\n하늘에 떠있는 저별과 같이\n8월의 여름날 날씨와 같이\n우린 아마 뜨거울거야\n\n{이밤이 지나도 우린 아마 사라지지않을거야\n언젠가 다시 만나면 그때 우리 다시 웃으며 만날거야}\n\n골목에 서있는 가로등 같이\n하늘에 떠있는 보름달 같이\n우린 아마 조금 외롭겠지만\n\n오래된 노래의 한 소절 같이\n유명한 소설의 한 구절 같이\n우린 아마 영원할거야\n\n{이밤이 지나도 우린 아마 사라지지않을거야\n언젠가 다시 만나면 그때 우리 다시 웃으며 만날거야}\n\n사랑했던 날도 행복했던 날도 이젠 없지만\n눈물짓던 날도 아파했던 날도 잊지않을거야\n이맘도 노래도 저별도 사랑도 \n언젠가 분명히 \n\n{이밤이 지나도 우린 아마 사라지지않을거야\n언젠가 다시 만나면 그때 우리 다시 웃으며 만날거야}\n\n"
    },
    {
      "bass": [
        "임은수"
      ],
      "drum": [
        "이유준"
      ],
      "guitar": [
        "이주원",
        "박준영"
      ],
      "keyboard": [
        "황정빈",
        "장우종"
      ],
      "number": "13",
      "songArtist": "유다빈밴드",
      "songName": "사랑한다는 말로도 위로가 되지 않는",
      "vocal": [
        "김다솔",
        "김준서"
      ]
    },
    {
      "bass": [
        "이승하"
      ],
      "drum": [
        "이유진"
      ],
      "guitar": [
        "조현호",
        "이주원"
      ],
      "keyboard": [
        "장우종",
        "황정빈"
      ],
      "number": "14",
      "songArtist": "자우림",
      "songName": "스물 다섯, 스물 하나",
      "vocal": [
        "김민지"
      ]
    },
    {
      "bass": [
        "배유호"
      ],
      "drum": [
        "이유진"
      ],
      "guitar": [
        "조현호",
        "강재호"
      ],
      "keyboard": [
        "장우종"
      ],
      "number": "15",
      "songArtist": "기리보이",
      "songName": "하루종일(Band Ver.)",
      "vocal": [
        "최승혜"
      ]
    },
    {
      "bass": [
        "한지우"
      ],
      "drum": [
        "김석진"
      ],
      "guitar": [
        "강재호",
        "이주원"
      ],
      "keyboard": [
        "김민정"
      ],
      "number": "16",
      "songArtist": "TOUCHED",
      "songName": "새벽별",
      "vocal": [
        "이시연"
      ]
    },
    {
      "bass": [
        "임은수"
      ],
      "drum": [
        "이유진"
      ],
      "guitar": [
        "김상경",
        "김원후"
      ],
      "keyboard": [
        "김민지"
      ],
      "number": "17",
      "songArtist": "브로큰 발렌타인",
      "songName": "알루미늄",
      "vocal": [
        "안병규",
        "이주원"
      ]
    },
    {
      "bass": [
        "홍윤표"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "이지호",
        "박준영"
      ],
      "keyboard": [
        "이서영"
      ],
      "number": "18",
      "songArtist": "Tokyo Jihen",
      "songName": "Marunouchi Sadistic",
      "vocal": [
        "이시연"
      ]
    },
    {
      "bass": [
        "이승하"
      ],
      "drum": [
        "김석진"
      ],
      "guitar": [
        "강재호",
        "김민제"
      ],
      "keyboard": [
        "장우종"
      ],
      "number": "19",
      "songArtist": "민수",
      "songName": "민수는 혼란스럽다",
      "vocal": [
        "최현석"
      ]
    },
    {
      "bass": [
        "배유호"
      ],
      "drum": [
        "이유준"
      ],
      "guitar": [
        "박준영"
      ],
      "keyboard": [
        "박민석",
        "이서은"
      ],
      "number": "20",
      "songArtist": "버스커버스커",
      "songName": "막걸리나",
      "vocal": [
        "안병규"
      ]
    },
    {
      "bass": [
        "임은수"
      ],
      "drum": [
        "김석진"
      ],
      "guitar": [
        "김민제",
        "박준영"
      ],
      "keyboard": [
        "이서은"
      ],
      "number": "21",
      "songArtist": "TOUCHED",
      "songName": "Highlight",
      "vocal": [
        "김준서"
      ]
    },
    {
      "bass": [
        "홍윤표"
      ],
      "drum": [
        "한지우"
      ],
      "guitar": [
        "김상경",
        "권예찬"
      ],
      "number": "22",
      "songArtist": "FT-ISLAND",
      "songName": "PRAY",
      "vocal": [
        "김선우"
      ]
    },
    {
      "bass": [
        "배유호"
      ],
      "drum": [
        "안승환"
      ],
      "guitar": [
        "조현호",
        "박준영"
      ],
      "keyboard": [
        "이서은",
        "박민석"
      ],
      "number": "23",
      "songArtist": "부활",
      "songName": "Lonely Night",
      "vocal": [
        "박지한"
      ]
    },
    {
      "bass": [
        "한지우"
      ],
      "drum": [
        "김석진"
      ],
      "guitar": [
        "김상경",
        "김원후"
      ],
      "keyboard": [
        "박민석",
        "이서영"
      ],
      "number": "24",
      "songArtist": "체감온도 17도",
      "songName": "내 노래는 푸르다",
      "vocal": [
        "김민정"
      ]
    }
  ]
}